import "./ProjectTreeHandleValidator.css";

import { useDispatch, useSelector } from "react-redux";

import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import FlakyOutlinedIcon from "@mui/icons-material/FlakyOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

import { ExpertEstmStatusEnum, ExpertEstmStatusTitleEnum } from "core/enums";
import { applyValidToProjectTreeRow } from "slices/estimateViewer/services";
import { getProjectTreeSelected } from "slices/project_work";

const ProjectTreeHandleValidator = ({ rowObj }) => {
	const dispatch = useDispatch();
	const projectTreeSelected = useSelector(getProjectTreeSelected);

	let icon;
	let nextVal;
	let title = "";

	if (rowObj?.expert_handle_valid === ExpertEstmStatusEnum.UPLOAD || rowObj?.expert_handle_valid == null) {
		icon = <FlakyOutlinedIcon />;
		nextVal = ExpertEstmStatusEnum.VALID;
		title = ExpertEstmStatusTitleEnum.UPLOAD;
	} else if (rowObj?.expert_handle_valid === ExpertEstmStatusEnum.VALID) {
		icon = <CheckCircleOutlinedIcon />;
		nextVal = ExpertEstmStatusEnum.NOT_VALID;
		title = ExpertEstmStatusTitleEnum.VALID;
	} else if (rowObj?.expert_handle_valid === ExpertEstmStatusEnum.NOT_VALID) {
		icon = <HighlightOffOutlinedIcon />;
		nextVal = ExpertEstmStatusEnum.UPLOAD;
		title = ExpertEstmStatusTitleEnum.NOT_VALID;
	}

	const handleClick = () => {
		if (projectTreeSelected?.length) {
			dispatch(applyValidToProjectTreeRow({ status: nextVal, treeRows: [...projectTreeSelected, rowObj] }));
		} else {
			dispatch(applyValidToProjectTreeRow({ status: nextVal, treeRows: [rowObj] }));
		}
	};

	return (
		<span className="project-tree-validator" onClick={handleClick} title={title}>
			{icon}
		</span>
	);
};

export default ProjectTreeHandleValidator;
